import React from "react";
import { Author } from "./author";
import { Link } from "gatsby";
import { slugify } from "@utils/helpers";
import * as c from "./authorPhotoNameTitle.module.scss";

export const AuthorPhotoNameTitle = ({ author: { photo, name, title, activeProfile }, className }) => {
  const authorSlug = slugify(name);

  return (
    <Author className={`${className}`}>
      <Author.photo photo={photo} alt={name} />
      <Author.caption>
        <b>By </b>
        {activeProfile ? (
          <Link to={`/blog/author/${authorSlug}`} className={c.textLink}>
            <b className={c.name}>{name}</b>
          </Link>
        ) : (
          <b>{name}</b>
        )}
        <p>{title}</p>
      </Author.caption>
    </Author>
  );
};
